// Packages
import React from 'react';

// Hooks
import { KiteCard, KiteGrid, KiteGridCell } from '@kite/react-kite';
import { useAuthUser } from '../../hooks/useAuthUser';

// Components
import Layout from '../../components/Layout/Layout';

// Types

// Styles
import './Profile.scss';

const Profile = () => {
  const { authUser } = useAuthUser();
  const fullName = `${authUser?.firstName} ${authUser?.lastName}`;

  return (
    <Layout className="profile">
      <KiteGrid>
        <KiteGridCell col={12}>
          <KiteCard>
            <span className="profile__full-name">{fullName}</span>
          </KiteCard>
        </KiteGridCell>
        <KiteGridCell col={12}>
          <KiteCard>
            <div>
              <dl>
                <dt>User ID</dt>
                <dd>{authUser?.pid}</dd>
              </dl>
            </div>
          </KiteCard>
        </KiteGridCell>
        <KiteGridCell col={12}>
          <KiteCard>
            <div>
              <dl>
                <dt>Email Address</dt>
                <dd>{authUser?.email}</dd>
              </dl>
            </div>
          </KiteCard>
        </KiteGridCell>
      </KiteGrid>
    </Layout>
  );
};

export default Profile;
